/* eslint-disable */
// @ts-nocheck

import { FileUploaderDropContainer } from "@carbon/react";
import { useState } from "react";

interface IProps {
  classname?: string;
  accept?: string[];
  labelText: string;
  labelTitle?: string;
  labelDescription?: string;
  multiple?: boolean;
  filenameStatus?: string;
  onAddFiles?: (file) => void;
  disabled?: boolean;
}

const DragndropContainer = ({
  classname = "",
  accept = [".csv", "text/csv"],
  labelText,
  labelTitle,
  labelDescription,
  multiple = false,
  filenameStatus,
  onAddFiles,
  disabled,
}: IProps) => {
  const [files, setFiles] = useState([]);

  return (
    <>
      {" "}
      <FileUploaderDropContainer
        className={disabled ? "darg-n-drop-disabled" : classname}
        accept={accept}
        labelText={labelText}
        labelTitle={labelTitle}
        labelDescription={labelDescription}
        multiple={multiple}
        filenameStatus={filenameStatus}
        onAddFiles={(event, { addedFiles }) => {
          if (event.target?.files) {
            onAddFiles(event.target.files[0]);
          } else {
            const files = { addedFiles };
            onAddFiles(files.addedFiles[0]);
          }
        }}
        disabled={disabled}
      />
    </>
  );
};

export default DragndropContainer;
